var localeData = require('../en.json')
exports = module.exports = localeData
exports['default'] = localeData